import { Icon } from "semantic-ui-react";

import { DayplannerStatusOptions } from "modules/Dayplanner/utils";

import type { DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS } from "models";

type StatusFilterProps = {
  count: number;
  filter: DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS;
  disabled: boolean;
  onClick: (filter: DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS | null) => void;
};

const StatusIcon = ({ filter }: { filter: DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS }) => {
  const icon = DayplannerStatusOptions.get(filter)?.icon;

  if (icon === "bo") {
    return (
      <div className="backorder-icon">
        <span>BO</span>
      </div>
    );
  }

  return icon ? <Icon className={icon} /> : null;
};

export const StatusButton = ({ count, filter, onClick, disabled }: StatusFilterProps) => {
  const color = DayplannerStatusOptions.get(filter)?.color ?? "#FFFFFF";

  return (
    <div className={`DayplannerStatusFilter ${disabled ? "disabled" : "clickable"}`} style={{ borderColor: color }} onClick={() => onClick(filter)}>
      <div style={{ backgroundColor: color }} className="DayplannerStatusFilter-icon">
        <StatusIcon filter={filter} />
      </div>
      <div className="DayplannerStatusFilter-count">{count}</div>
    </div>
  );
};
